(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpc-demo-day-rsvp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRSVP() {
      const STORAGE_KEY = 'rsvp-event-details';

      const formContainerEl = document.getElementById('rsvp-form-container');
      const formEl = formContainerEl ? formContainerEl.querySelector('form') : null;

      const eventDetailsEl = document.getElementById('rsvp-event-details');
      const fallbackMessageEl = document.getElementById('rsvp-fallback-message');
      const infoBoxEl = document.getElementById('rsvp-info-box');

      const dateDisplayEl = document.getElementById('rsvp-event-date');
      const timeDisplayEl = document.getElementById('rsvp-event-time');
      const locationDisplayEl = document.getElementById('rsvp-event-location');

      const dateInputEl = document.getElementById('contact-event-date');
      const timeInputEl = document.getElementById('contact-event-time');
      const locationInputEl = document.getElementById('contact-event-location');
      const returnToInput = document.getElementById('rsvp-return-to');

      const successMessageEl = document.getElementById('rsvp-success-message');

      /*
       * Shopify can return to the same page with contact_posted=true
       * after a successful contact form submission.
       */
      const urlParams = new URLSearchParams(window.location.search);

      const eventDate = urlParams.get('date');
      const eventTime = urlParams.get('time');
      const eventLocation = urlParams.get('location');

      const contactPosted = urlParams.get('contact_posted') === 'true';

      /*
       * The Liquid form.posted_successfully? check is the most reliable
       * server-side success indicator.
       */
      const liquidSuccess = !!successMessageEl;

      /*
       * SUCCESS MUST TAKE PRIORITY over event URL parameters.
       */
      const isFormSuccess = liquidSuccess || contactPosted;

      /*
       * Prevent browser from restoring the previous scroll position.
       */
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      /*
       * Decode URL values safely.
       */
      function decodeValue(value) {
        if (!value) return '';

        try {
          return decodeURIComponent(value);
        } catch (e) {
          return value;
        }
      }

      /*
       * Populate event information.
       */
      function populateEventDetails(date, time, location) {
        const decodedDate = decodeValue(date);
        const decodedTime = decodeValue(time);
        const decodedLocation = decodeValue(location);

        if (dateDisplayEl) {
          dateDisplayEl.textContent = decodedDate;
        }

        if (timeDisplayEl) {
          timeDisplayEl.textContent = decodedTime;
        }

        if (locationDisplayEl) {
          locationDisplayEl.textContent = decodedLocation;
        }

        if (dateInputEl) {
          dateInputEl.value = decodedDate;
        }

        if (timeInputEl) {
          timeInputEl.value = decodedTime;
        }

        if (locationInputEl) {
          locationInputEl.value = decodedLocation;
        }

        if (eventDetailsEl) {
          eventDetailsEl.style.display = 'block';
        }

        if (infoBoxEl) {
          infoBoxEl.style.display = 'block';
        }

        if (formContainerEl) {
          formContainerEl.style.display = 'block';
        }
      }

      /*
       * Scroll RSVP section to the top.
       */
      function scrollToTop() {
        const topAnchor = document.getElementById('rsvp-top');

        if (topAnchor) {
          topAnchor.scrollIntoView({
            behavior: 'auto',
            block: 'start',
          });
        }

        requestAnimationFrame(function () {
          window.scrollTo(0, 0);

          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 100);
        });
      }

      /*
       * ------------------------------------------------------------
       * SUCCESS STATE
       * ------------------------------------------------------------
       *
       * This MUST run before checking date/time/location parameters.
       */
      if (isFormSuccess) {
        if (formContainerEl) {
          formContainerEl.style.display = 'block';
        }

        if (fallbackMessageEl) {
          fallbackMessageEl.style.display = 'none';
        }

        /*
         * Restore event information from sessionStorage.
         */
        let storedData = null;

        try {
          const stored = sessionStorage.getItem(STORAGE_KEY);

          if (stored) {
            storedData = JSON.parse(stored);
          }
        } catch (e) {
          storedData = null;
        }

        if (storedData && storedData.date && storedData.time && storedData.location) {
          populateEventDetails(storedData.date, storedData.time, storedData.location);

          /*
           * Do not keep old event data indefinitely.
           */
          try {
            sessionStorage.removeItem(STORAGE_KEY);
          } catch (e) {}
        }

        /*
         * Make sure the confirmation is visible.
         */
        if (successMessageEl) {
          successMessageEl.style.display = 'block';
        }

        /*
         * Scroll to RSVP confirmation.
         */
        setTimeout(function () {
          const confirmation = document.getElementById('rsvp-confirmation');

          if (confirmation) {
            confirmation.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          } else {
            scrollToTop();
          }
        }, 100);

        /*
         * Clean the success parameter from the URL while keeping
         * the page URL clean.
         */
        if (contactPosted) {
          try {
            const cleanUrl = new URL(window.location.href);

            cleanUrl.searchParams.delete('contact_posted');

            /*
             * Remove event parameters after successful submission.
             * The event details are already restored from sessionStorage.
             */
            cleanUrl.searchParams.delete('date');
            cleanUrl.searchParams.delete('time');
            cleanUrl.searchParams.delete('location');

            history.replaceState(
              {},
              document.title,
              cleanUrl.pathname + (cleanUrl.search ? cleanUrl.search : '') + '#rsvp-confirmation'
            );
          } catch (e) {}
        }

        return;
      }

      /*
       * ------------------------------------------------------------
       * NORMAL RSVP PAGE
       * ------------------------------------------------------------
       */

      if (eventDate && eventTime && eventLocation) {
        /*
         * Store event information BEFORE submitting.
         * This allows us to restore it after Shopify redirects.
         */
        try {
          sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
              date: decodeValue(eventDate),
              time: decodeValue(eventTime),
              location: decodeValue(eventLocation),
            })
          );
        } catch (e) {}

        populateEventDetails(eventDate, eventTime, eventLocation);

        /*
         * Set Shopify return URL.
         *
         * IMPORTANT:
         * contact_posted=true tells the page that the form was
         * successfully submitted after Shopify redirects back.
         */
        if (formEl && returnToInput) {
          formEl.addEventListener('submit', function () {
            const currentPath = window.location.pathname;

            /*
             * We intentionally don't use the current query string here.
             * The event information is already stored in sessionStorage.
             */
            returnToInput.value = currentPath + '?contact_posted=true#rsvp-top';
          });
        }

        return;
      }

      /*
       * ------------------------------------------------------------
       * NO EVENT SELECTED
       * ------------------------------------------------------------
       */

      if (fallbackMessageEl) {
        fallbackMessageEl.style.display = 'block';
      }

      if (formContainerEl) {
        formContainerEl.style.display = 'none';
      }

      if (eventDetailsEl) {
        eventDetailsEl.style.display = 'none';
      }

      if (infoBoxEl) {
        infoBoxEl.style.display = 'none';
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRSVP);
    } else {
      initRSVP();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
